module.exports = __webpack_public_path__ + "img/026-machine-learning-2.3ec86212.png";